<template>
    <div id="create_code_component"
         class="create-code-component"
         style="margin-bottom: 11px">
        <p style="margin-bottom: 11px">Create unique voucher and give it to your friend</p>
        <form @submit.prevent="validate">
            <b-row>
                <b-col lg="4" cols="12">
                    <div class="form-item form-item-amount">
                        <div class="transfer-value" :class="{ 'field-error': errors.has('code_value') || available < 0 }">
                            <input type="text"
                                   name="code_value"
                                   v-validate
                                   data-vv-rules="required|money|greaterThanZero"
                                   data-vv-as="code value"
                                   v-model="codeValue"
                                   :disabled="progress || true">
                            <div class="currency">FND</div>
                        </div>
                        <p class="field-error--description"
                           v-show="errors.has('code_value') && showErrors">{{ errors.first('code_value') }}</p>
                        <p class="field-error--description"
                           v-show="available < codeValue && showErrors">Not enough founds</p>
                    </div>
                </b-col>
                <b-col lg="4" cols="12">
                    <button class="button--primary"
                            :class="{ 'button--progress': progress }"
                            :disabled="progress || true">Create</button>
                </b-col>
            </b-row>
        </form>
    </div>
</template>

<script>
    export default {
        dependencies: ['code', 'money', 'user'],
        data () {
            return {
                codeValue: 0,
                showErrors: true
            }
        },
        computed: {
            available() {
                return this.money.format(this.$store.getters.user.moneyBalance, 'fnd')
            },
            progress() {
                return this.$store.getters.codes.isCreateLoading
            }
        },
        methods: {
            validate () {
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.code.createCode(this.money.unformat(this.codeValue, 'fnd'))
                    } else {
                        this.showErrors = true
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/codes/CreateCode.vue